import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { Get, Post } from 'Xhr/Xhr';

export const GetPatientForVizitInput = async (
  setInputParams
) => {
  Get(
    `${process.env.REACT_APP_API_URL_API_GET_PATIENTS_FOR_VISIT_INPUT}`,
    true,
    {}
  ).then((response) => {
    if (response.data.resCode === 1) {
      setInputParams({
        ...response.data.Data,
        TypeList: response.data.Data.TypeList.map(
          (list) => ({
            ItemContent: ArabicToPersian(list.Name),
            ItemValue: list.Id,
          })
        ),
      });
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
